import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormCapsule: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFormCapsule"><Path d="M14.5 4.5H9.5C5.35786 4.5 2 7.85786 2 12C2 16.1421 5.35786 19.5 9.5 19.5H14.5C18.6421 19.5 22 16.1421 22 12C22 7.85786 18.6421 4.5 14.5 4.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFormCapsule;
